import { ClusterOutlined } from '@ant-design/icons'
import { Badge, Button, Tooltip } from 'antd'
import React from 'react'

function ChannelBanButton({ handleClick, is24H, isLoading }: { handleClick: () => void, is24H: boolean , isLoading: boolean }) {
  return (
    <Tooltip title={is24H ? "24-hour Channel Ban" : "Channel Ban"}>
    <Badge

      count={is24H ? "24h" : ""}
      style={{
        width: 16,
        height: 16,
        borderRadius: "100%",
        fontSize: 7,
        alignItems: 'center',
      }}
      offset={[-5, 5]}
    >
      <Button
        variant="outlined"
        onClick={handleClick}
        icon={<ClusterOutlined />}
        loading={isLoading}
        style={{
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "4px 8px",
        }}
      />
    </Badge>
    </Tooltip>
  )
}

export default ChannelBanButton;
